import LoadingState from "../components/basic/loading-state";
import Inbox from "./Inbox";
import type { InboxProps } from "./Inbox";

type MessagesProps = Omit<InboxProps, "accounts"> & {
  accounts?: InboxProps["accounts"];
  loading?: boolean;
};

export default function Messages({
  accounts,
  loading = false,
  initialAccount,
  fetchApi,
  fetchMultipart,
  busy,
  setBusy,
  setError,
  flashSuccess,
  liveRevision,
  processRunning,
  setConfirmPopup,
  onOpenAccountSettings,
}: MessagesProps) {
  if (!accounts?.length) {
    return (
      <div className="ib-messages-view">
        {loading ? (
          <LoadingState label="Loading accounts…" />
        ) : (
          <div className="ib-empty">
            <div className="ib-empty__title">No accounts yet</div>
            <div className="ib-empty__text">
              Add accounts to see their conversations here.
            </div>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="ib-messages-view">
      <Inbox
        accounts={accounts}
        initialAccount={initialAccount}
        fetchApi={fetchApi}
        fetchMultipart={fetchMultipart}
        busy={busy}
        setBusy={setBusy}
        setError={setError}
        flashSuccess={flashSuccess}
        liveRevision={liveRevision}
        processRunning={processRunning}
        setConfirmPopup={setConfirmPopup}
        onOpenAccountSettings={onOpenAccountSettings}
      />
    </div>
  );
}
